import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";

export async function GetMyDetails() {
  try {
    const response = await api.get("accounts/users/me/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function findMyOrg() {
  try {
    const response = await api.get("organization/self/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function getMyOrgDetails() {
  try {
    const response = await api.get("organization/profile/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function EditMyOrg(Id, formData) {
  try {
    const response = await api.put(
      "organization/profile/",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function GetMyOrgUsers(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounts/organization-users/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounts/organization-users/", {
        params,
      });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

// In MyProfileApi.js
export async function AddOrgUser(formData) {
  try {
    const response = await api.post(
      "accounts/organization-users/create/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    const message = error?.response?.data?.message || "Something went wrong.";
    showAlert(message);
    return null;
  }
}

export async function EditMyOrgUsers(Id, formData) {
  try {
    const response = await api.patch(
      `accounts/organization-users/update/?id=${Id}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function OrgUsersDelete(id) {
  try {
    const response = await api.delete(
      `accounts/organization-users/delete/?id=${Array.isArray(id) ? id.join(',') : id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function OrgUserArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("accounts/organization-users/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`accounts/organization-users/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetMyOrgroles(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`accounts/organization-roles/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("accounts/organization-roles/", {
        params,
      });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function AddMyOrgroles(formData) {
  try {
    const response = await api.post("accounts/organization-roles/", formData);
    return response;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function EditMyOrgroles(Id, formData) {
  try {
    const response = await api.put(
      `accounts/organization-roles/?id=${Id}`,
      formData,
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function OrgRolesArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("accounts/organization-roles/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`accounts/organization-roles/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function OrgRolesDelete(id) {
  try {
    const response = await api.delete(
      `accounts/organization-roles/delete/?id=${Array.isArray(id) ? id.join(',') : id}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetLanguages() {
  try {
    const response = await api.get("localization/languages/active/");
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function GetUserRoles() {
  try {
    const response = await api.get("accounts/roles/organizational/active/");
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ActiveUserRoles() {
  try {
    const response = await api.get("accounts/organization-roles/active");
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

//Permissions

export async function GetPermissions() {
  try {
    const response = await api.get("accounts/permissions/organizational/");
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

//Change Passowrd

export async function ChangePassword(formData) {
  try {
    const response = await api.post(
      "accounts/organization-users/change-password/",
      formData,
    );
    return response;
  } catch (error) {
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

//Currency

export async function CurrencyList() {
  try {
    const response = await api.get("organization/currencies/active/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function GetOrganizationCurrencyDropdown() {
  try {
    const response = await api.get("organization/currencies/dropdown/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

//Languages

export async function LanguageList() {
  try {
    const response = await api.get("localization/languages/active/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

//UserTimeZone
export async function timezoneList() {
  try {
    const response = await api.get("localization/timezones/list/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function RequestUserLimitExtension(additional_user_count) {
  try {
    const response = await api.post("subscriptions/user-limit-extension/", {
      additional_user_count,
    });

    return response;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

export async function RequestPlanExtension() {
  try {
    const response = await api.post("subscriptions/plan-extension/", {});
    return response;
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Something went wrong");
  }
}

// Get Current Subscription Plan
export async function GetCurrentPlan() {
  try {
    const response = await api.get("subscriptions/current-plan/");
    return response.data; // return data only
  } catch (error) {
    console.log(error);
    showAlert(error.response?.data?.message || "Failed to load current plan");
  }
}

export async function EditMyProfileAPI(formData) {
  try {
    const response = await api.put("accounts/users/me/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Profile update failed");
    return error?.response;
  }
}

export const saveTermsAndConditions = async (payload) => {
  try {
    const response = await api.post(
      `organization/terms-and-conditions/manage/`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTermsAndConditions = async () => {
  try {
    const response = await api.get("organization/terms-and-conditions/");
    return response;
  } catch (error) {
    throw error;
  }
};

export async function GetBillingHistory() {
  try {
    const response = await api.get("subscriptions/invoices/");
    return response.data;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Failed to load billing history");
  }
}

/* ==================== NEW AUTOPAY APIS ==================== */

export async function GetAutopayStatus() {
  try {
    const response = await api.get("subscriptions/autopay/status/");
    return response.data;        // Returns { success, data: { autopay_enabled, ... } }
  } catch (error) {
    console.log(error);
    showAlert(error?.response?.data?.message || "Failed to load autopay status");
    return null;
  }
}

export async function CancelAutopay() {
  try {
    const response = await api.post("subscriptions/autopay/cancel/");
    return response.data;        // Returns { success, message }
  } catch (error) {
    console.log(error);
    showAlert(error?.response?.data?.message || "Failed to cancel autopay");
    throw error;                 // Let the caller handle the error if needed
  }
}

export async function EnableAutopay() {
  try {
    const response = await api.post("subscriptions/autopay/enable/");
    return response.data;        // Returns { success, message }
  } catch (error) {
    console.log(error);
    showAlert(error?.response?.data?.message || "Failed to enable autopay");
    throw error;
  }
}

export async function OrganizationReset(username, password) {
  try {
    const response = await api.post("organization/reset/", {
      username,
      password,
      confirmation: "DELETE ALL DATA",
    });

    return response;

  } catch (error) {
    showAlert(
      error?.response?.data?.message ||
      "Failed to reset organization data"
    );
    throw error;
  }
}

export async function OrganizationDeactivation(username, password) {
  try {
    const response = await api.post("organization/deactivate/", {
      username,
      password,
      confirmation: "DEACTIVATE ACCOUNT",
    });

    return response;

  } catch (error) {
    showAlert(
      error?.response?.data?.message ||
      "Failed to deactivate organization"
    );
    throw error;
  }
}

export async function getOrganizationBanks(params = {}) {
  try {
    const response = await api.get("organization/banks/", { params });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function addOrganizationBank(bankData) {
  try {
    const response = await api.post("organization/banks/", bankData);
    return response.data;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Failed to add bank details");
  }
}

export async function editOrganizationBank(id, bankData) {
  try {
    const response = await api.put(`organization/banks/?id=${id}`, bankData);
    return response.data;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Failed to edit bank details");
  }
}

export async function deleteOrganizationBank(id) {
  try {
    const response = await api.delete(`organization/banks/?id=${id}`);
    return response.data;
  } catch (error) {
    showAlert(error?.response?.data?.message || "Failed to delete bank details");
  }
}